import * as React from 'react';
import {useAppTranslation} from 'services/i18n';

const styles: { [key: string]: { background: string, color: string } } = {
    draft: {background: 'var(--color-warning-back)', color: '#8A5A00'},
    approved: {background: 'var(--color-success-back)', color: '#4A7500'},
    rejected: {background: 'var(--color-error-back)', color: '#A32409'},
    // withdrawn by the requester, not a decision -- neutral, so it does not read
    // as another kind of refusal
    cancelled: {background: '#E0E0E0', color: 'var(--color-black-text)'},
};

export const ApprovalStatusTag = ({status}: { status?: string | null }) => {
    const t = useAppTranslation();

    if (!status) {
        return <>&mdash;</>;
    }

    return <span className={'tw-rounded-md tw-py-4 tw-px-8 tw-text-12 tw-whitespace-nowrap'}
        style={styles[status]}>{t('approvals.status.' + status)}</span>;
};
